import React from 'react'
import i18next from 'i18next'
import { PriceType, Product } from '../../../../models/Events/Events'

export interface priceListProps {
  products: Product[]
}

const formatPrice = (price: number) => {
  return price.toLocaleString('nl-NL', { style: 'currency', currency: 'EUR' })
}

const renderPriceTerm = (label: string, price: number | null) => (
  <>
    <dt className="specs__term">{label}:</dt>
    <dd className="specs__def">{price === null ? "n.v.t."
    : price === -1 ? "Op aanvraag"
    : price === 0 ? "Gratis"
    : formatPrice(price)}</dd>
  </>
)

export const PriceListBlock = (props: priceListProps): JSX.Element => {
  const { products } = props
  const nonMemberPrice = products && products.length > 0 && products.find((product) => !product.additional_product && product.price_type === PriceType.NONMEMBER)
  const memberPrice = products && products.length > 0 && products.find((product) => !product.additional_product && product.price_type === PriceType.MEMBER)
  const examMemberPrice = products && products.length > 0 && products.find((product) => product.additional_product && product.price_type === PriceType.MEMBER)
  const examPrice = products && products.length > 0 && products.find((product) => product.additional_product && product.price_type === PriceType.NONMEMBER)

  const isEqualPrice = (price1: any, price2: any) =>
    price1 && price2 && price1.amount === price2.amount

  const renderMemberAndNonMemberPrice = () => (
    <>
      {renderPriceTerm(
        i18next.t('courses:price'),
        nonMemberPrice && nonMemberPrice.amount !== undefined
          ? nonMemberPrice.amount
          : null
      )}

      {renderPriceTerm(
        i18next.t('courses:memberPrice'),
        memberPrice && memberPrice.amount !== undefined
          ? memberPrice.amount
          : null
      )}
    </>
  )

  const renderExamAndMemberExamPrice = () => (
    <>
      {examPrice && examPrice.amount !== undefined &&
        renderPriceTerm(i18next.t('courses:examCost'), examPrice.amount)
      }
      {examMemberPrice && examMemberPrice.amount !== undefined &&
        renderPriceTerm(i18next.t('courses:memberExamCost'), examMemberPrice.amount)
      }
    </>
  )

  return (
    <>
      {nonMemberPrice && memberPrice && isEqualPrice(nonMemberPrice, memberPrice)
        ? renderPriceTerm(i18next.t('courses:price'), nonMemberPrice.amount)
        : renderMemberAndNonMemberPrice()
      }

      {examPrice && examMemberPrice && isEqualPrice(examPrice, examMemberPrice)
        ? renderPriceTerm(i18next.t('courses:examCost'), examPrice.amount)
        : renderExamAndMemberExamPrice()
      }
    </>
  )
}
